import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
  SaveButton,
} from "@components";

import { createDossier } from "@api/dossier";

import { convertDocumentData } from "@utils/documentDataConvert";

import { STATUS } from "@constants/status.hrm";

import {
  ADD_DOSSIER,
  DossierFormData,
  dossierValidation,
} from "@validations/HRM/employee/dossierValidation";

const { SUCCESS, FAILED } = STATUS;

export interface AddDossierPropsType {
  id: number | null;
  data: any;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
}

export const AddDossier = ({
  id,
  data,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
}: AddDossierPropsType) => {
  const { t } = useTranslation();

  const { handleAddNewDossier } = data || {};

  const methods = useForm<DossierFormData>({
    resolver: yupResolver(dossierValidation),
  });

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
    control,
    setValue,
  } = methods;

  const onSubmit: SubmitHandler<DossierFormData> = (data: DossierFormData) => {
    createDossier(
      id as number,
      convertDocumentData(data, ADD_DOSSIER.DOCUMENTS),
      (response) => {
        setIsErrorModalOpen(false);
        if (response.status === SUCCESS) {
          reset();
          setIsSuccessModalOpen(true);
          handleAddNewDossier(response.data);
        } else if (response.status === FAILED) setIsErrorModalOpen(true);
      },
    );
  };

  return (
    <form className="container py-8" onSubmit={handleSubmit(onSubmit)}>
      <div className=" d-flex flex-column gap-8">
        <Text
          weight="semibold"
          size="lg"
          color="subtitle1"
          className="pb-8 border-bottom"
        >
          {t("EMPLOYEE.DOSSIER_INFO.FORM.HEADING")}
        </Text>
        <InputTextRow
          register={{ ...register(ADD_DOSSIER.NAME) }}
          label="EMPLOYEE.DOSSIER_INFO.FORM.NAME"
          error={errors}
          required
        />
        <InputTextRow
          register={{ ...register(ADD_DOSSIER.REMARKS) }}
          label="EMPLOYEE.DOSSIER_INFO.FORM.REMARKS"
          error={errors}
        />
        <InputDateControllerRow
          label="EMPLOYEE.DOSSIER_INFO.FORM.DATE"
          control={control}
          register={{ ...register(ADD_DOSSIER.DATE) }}
          errors={errors}
          name={ADD_DOSSIER.DATE}
          required
        />
        <MultiFileRow
          label="EMPLOYEE.DOSSIER_INFO.FORM.UPLOAD_DOCUMENTS"
          name={ADD_DOSSIER.DOCUMENTS}
          control={control}
          setValue={setValue}
          register={register}
          error={errors}
          fileDetails={["memorialNo"]}
        />
      </div>
      <SaveButton />
    </form>
  );
};
